export default "__VITE_ASSET__DNVfhu9w__"